var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header',{attrs:{"title-ch":"實習業務","title-en":"INTERNSHIP BUSINESS"}})
}
var staticRenderFns = []

export { render, staticRenderFns }